import { render, staticRenderFns } from "./ProfileStudentOld.vue?vue&type=template&id=c127b324&scoped=true"
import script from "./ProfileStudentOld.vue?vue&type=script&lang=js"
export * from "./ProfileStudentOld.vue?vue&type=script&lang=js"
import style0 from "./ProfileStudentOld.vue?vue&type=style&index=0&id=c127b324&prod&scoped=true&lang=css"
import style1 from "./ProfileStudentOld.vue?vue&type=style&index=1&id=c127b324&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c127b324",
  null
  
)

export default component.exports